import React, { useState, useEffect, useRef } from 'react'
import classes from './BackgroundTitle.module.scss';

const BackgroundTitle = ({ children, parentClass, small, className, style })=> {
    const [transY, setTransY] = useState(0);
    const [offsetY, setOffsetY] = useState(0);
    const mainRef = useRef();

    useEffect(()=> {
        const parent = mainRef.current.closest('.' + parentClass);
        
        if (parent) {
            const pRect = parent.getBoundingClientRect();
            
            setOffsetY(pRect.top);
        }

        const scrollHandler = ()=> {
        setTransY(window.pageYOffset);
        }
        window.addEventListener('scroll', scrollHandler);

        return ()=> window.removeEventListener('scroll', scrollHandler);
    }, []);
    // console.log(transY, offsetY);

    const styles = {
        // bottom: 32 - offsetY,
        transform: `translate(0, ${transY - offsetY}px)`,
        ...style
    };
    return (
        <div className={classes.BackgroundTitle} ref={mainRef} style={styles}>
            <h1 className={[classes.Title, classes.Back].join(' ')}>{children}</h1>
            <h1 className={[classes.Title, classes.Back, classes.Back2].join(' ')}>{children}</h1>
            <h1 className={classes.Title}>{children}</h1>
        </div>
    )
}

export default BackgroundTitle
